<template>
  <div>
    <vetster-headless-modal
      ref="share"
      :header="$t('livechat.unlimited-chat-with-licensed-pet-care-team')"
      @close="close"
      @cancel="close"
    >
      <div class="mt-6 px-6 font-semibold text-neutral-900 text-2xl text-center leading-6">
        {{ $t('livechat.unlimited-chat-with-licensed-pet-care-team') }}
      </div>

      <div class="w-full flex justify-center mt-6 px-4 sm:px-0">
        <ul class="text-left text-sm space-y-2 *:space-x-2 text-neutral-700">
          <li class="flex">
            <div class="w-6 flex justify-center items-center">
              <fa
                :icon="['fal', 'infinity']"
                class="text-base text-bubblegum"
              />
            </div>
            <span>{{ $t('livechat.unlimited-chat-with-your-team') }}</span>
          </li>
          <li class="flex">
            <div class="w-6 flex justify-center items-center">
              <fa
                :icon="['fal', 'tag']"
                class="text-base text-bubblegum"
              />
            </div>
            <span>{{ $t('livechat.20%-off-appointments') }}</span>
          </li>
          <li class="flex">
            <div class="w-6 flex justify-center items-center">
              <fa
                :icon="['fal', 'ban']"
                class="text-base text-bubblegum"
              />
            </div>
            <span>{{ $t('livechat.no-commitments-cancel-anytime') }}</span>
          </li>
        </ul>
      </div>

      <div class="flex items-center justify-center">
        <slot name="store-icons" />
      </div>

      <div class="mt-6 relative h-[320px] sm:h-[270px] overflow-hidden">
        <div class="absolute inset-0 w-full mx-auto flex justify-center">
          <img
            src="https://images.vetster.com/photos/livechat-illustrations.png?ik-s=81d9166c8b7f0c8b03a8536700afdd184aaf5cc0"
            alt="Vetster Messaging with Vet Techs"
            class="absolute bottom-0 mt-6 h-[100%] sm:w-[75%] z-10"
          />
        </div>
        <img
          aria-hidden="true"
          src="https://images.vetster.com/photos/vetster-ocean-ellipse.png?ik-s=81d9166c8b7f0c8b03a8536700afdd184aaf5cc0"
          alt="Vetster Blob"
          class="absolute bottom-8 sm:bottom-0 w-full z-0 scale-150 sm:scale-100"
        >
      </div>
    </vetster-headless-modal>

    <div
      v-if="!loading && showButton"
      class="text-sm w-full"
    >
      <slot
        name="custom-trigger"
        :open-modal="openModal"
      >
        <div v-if="getIsOnline">
          <div class="mt-4 min-h-11">
            <vetster-button
              v-cloak
              href="#"
              :type="null"
              size="xl"
              variant="bubblegum"
              class="w-full"
              @click.prevent="openModal"
            >
              <fa
                :icon="['fas', 'messages']"
                class="text-xl"
              />
              <span class="whitespace-no-wrap text-center">{{ $t('livechat.chat-with-vetster-support') }}</span>
            </vetster-button>
          </div>

          <div class="mt-4 flex justify-center items-center space-x-2">
            <fa
              :icon="['fas', 'circle']"
              class="size-2 text-green-600"
            />
            <span class="text-center">{{ $t('livechat.chat-online') }}</span>
          </div>
        </div>
        <div v-else>
          <div
            v-cloak
            class="mt-4 min-h-11"
          >
            <vetster-button
              href="#"
              :type="null"
              size="fixed"
              variant="bubblegum"
              class="mt-4 xl:ml-0 xl:-mx-4 w-full"
              @click.prevent="openModal"
            >
              <fa
                :icon="['fas', 'messages']"
                class="text-xl"
              />
              <span class="whitespace-no-wrap text-center">{{ $t('livechat.chat-in-the-app') }}</span>
            </vetster-button>
          </div>

          <div class="mt-4 flex justify-center items-center space-x-2">
            <fa
              :icon="['fas', 'circle']"
              class="size-2 text-neutral-500"
            />
            <span class="text-center">{{ $t('livechat.chat-offline') }}</span>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { mapActions, mapGetters } from 'vuex';

import VetsterHeadlessModal from '@/components/VetsterHeadlessModal';
import { getCookie } from '@/helpers/cookies';

library.add(faCircle);

export default {
  name: 'VetsterLivechatCTA',

  components: { VetsterHeadlessModal },

  props: {
    eventChild: {
      type: String,
      default: 'content-cta',
    },
    eventParent: {
      type: String,
      default: 'content-page',
    },
    open: {
      type: Boolean,
      default: false,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      loading: true,
    };
  },

  computed: {
    ...mapGetters('livechat', ['getIsOnline']),
  },

  watch: {
    open(open) {
      if (open) {
        this.$refs.share?.open();
      } else {
        this.$refs.share?.close();
      }
    },
  },

  async created() {
    await this.fetchAvailability();
    this.loading = false;
  },

  methods: {
    ...mapActions('livechat', ['fetchAvailability']),
    close() {
      this.$emit('close');
    },
    openModal() {
      const uatId = getCookie('v-uatid');

      this.$analytics.track({
        eventName: 'chat_cta_click',
        parent: this.eventParent,
        child: this.eventChild,
        uat_id: uatId,
      });

      this.$refs.share?.open();
    },
  },
};
</script>
